export default __webpack_public_path__ + "static/media/ic.55b82263.png";